export default (state: Object, action: Object) => {
  const {
    payload: { response: ssrHrtvRespLineItems },
  } = action;

  return {
    ...state,
    ssrCreateShipToAddress: ssrHrtvRespLineItems[0].vendorReturnAddress,
  };
};
